import React from "react";
import "./PickemLayoutPage.scss";
import { PickemHeader } from "components/Headers/PickemHeader";

export const PickemLayoutPage = ({ children, title, subtitle, name, competitionName, competitionDescription, isDifferentUser=false }) => {

  return (
    <div className="PickemLayoutPage">
      <PickemHeader 
        title={title}
        subtitle={subtitle}
        name={name}
        isDifferentUser={isDifferentUser}
        competitionName={competitionName}
        competitionDescription={competitionDescription}
      />

      <div className="PickemLayoutPage-content">
        <div className="PickemLayoutPage-contentWrap">
          <div className="PickemLayoutPage-contentInnerWrap">{children}</div>
        </div>
      </div>
    </div>
  );
};
